import {OrdemServicoService} from '../service/ordem-servico.service';
import {constants} from '../app-constants';
import {Component, OnInit} from '@angular/core';
import {OrdemServicoIn, OrdemServicoModel} from '../model';
import {AdvGrowlService} from 'primeng-advanced-growl';
import {NgxUiLoaderService} from 'ngx-ui-loader';

import {PropertiesLocales} from '../util/properties-locale';
import {Router} from '@angular/router';
import {AmbienteModel} from '../model/ambiente.model';

@Component({
  selector: 'app-criar-osconfirmacao',
  templateUrl: './criar-osconfirmacao.component.html',
  styleUrls: ['./criar-osconfirmacao.component.css'],
})
export class CriarOSConfirmacaoComponent implements OnInit {
  pedido: any;
  endereco: any;
  ambientes: any;
  tipoOS: any;
  ativo: any;
  anexos: any;
  descricaoAtivo: any;
  osIn: OrdemServicoIn;
  public properties: PropertiesLocales = new PropertiesLocales();
  public message: any;
  public basePath: string;

  constructor(private router: Router,
              private ordemServico: OrdemServicoIn,
              private os: OrdemServicoModel,
              private osService: OrdemServicoService,
              private loadingBar: NgxUiLoaderService) {
    this.pedido = os;
    this.osIn = ordemServico;
   }

  ngOnInit() {
    this.basePath =  window.location.pathname;
    let local = localStorage.getItem(constants.locale);
    const uri = this.basePath.substring(7)
                              .replace('/', '')
                              .replace('/', '')
                              .toString();

    if (local !== uri) { // prevalece o locale definido na URL
      local = uri;
    }

    switch (local) {
      case 'es':
       this.message = this.properties.items_steps_es;
      break;
      case 'en':
      this.message = this.properties.items_steps_en;
      break;
      default:
      this.message = this.properties.items_steps_pt;
      break;
    }

    this.endereco = JSON.parse(localStorage.getItem(constants.enderecoSelecionadoKey));
    this.tipoOS = JSON.parse(localStorage.getItem(constants.tipoosSelecionadoKey));
    this.ativo = JSON.parse(localStorage.getItem(constants.ativoKey));
    this.ambientes = JSON.parse(localStorage.getItem(constants.ambientes));
    this.anexos = JSON.parse(localStorage.getItem(constants.anexosKey));
    this.pedido.ativo = this.ativo;

    if (this.pedido.ativo !== null && this.pedido.ativo !== undefined) {
      if (this.pedido.ativo.numeroSerie !== null) {
        this.descricaoAtivo = this.pedido.ativo.numeroSerie;
      }
      if (this.pedido.ativo.numeroPatrimonio !== null) {
        this.descricaoAtivo = this.descricaoAtivo + ' - ' + this.pedido.ativo.numeroPatrimonio;
      }
      if (this.pedido.ativo.descricaoTipoEquipamento !== null) {
        this.descricaoAtivo = this.descricaoAtivo + ' - ' + this.pedido.ativo.descricaoTipoEquipamento;
      }
      if (this.pedido.ativo.ambiente !== null &&
            this.pedido.ativo.ambiente !== '') {
        this.descricaoAtivo = this.descricaoAtivo + ' - ' + this.pedido.ativo.ambiente;
      }

      this.osIn.ativoId = this.pedido.ativo.ativoId;
    }
    this.pedido.endereco = this.endereco;
    this.pedido.tipoOS = this.tipoOS;
    this.pedido.ambientes = this.ambientes;
    this.osIn.codigoEndereco = this.endereco.codigoEndereco;
    this.osIn.codigoTipoOS = this.tipoOS.codigo;
    this.osIn.ambientes = this.ambientes;
    this.osIn.anexos = this.anexos;
  }

  public criarOs(advGrowlService: AdvGrowlService, msg: any) {
    this.loadingBar.start();
    this.osService.adicionar(this.osIn).subscribe(response => {
     this.httpResponse(response, advGrowlService, msg);
    });
  }

  public httpResponse(data: any, advGrowlService: AdvGrowlService, msg: any) {
    this.loadingBar.stop();
    this.clearLocalStorage();
    if (data.erros !== undefined) {
      advGrowlService.createTimedErrorMessage(data.erros[0].description, 'Error ::' + data.erros[0].code, 4000);
    } else {
      advGrowlService.createSuccessMessage( msg[19].msg_service_success_os_create, msg[14].msg_service_success);
      this.router.navigate(['/listaOrdemServico'], { queryParams: { msgSucesso: msg[19].msg_service_success_os_create } });
    }

  }


  clearLocalStorage() {
    localStorage.setItem(constants.ativoKey, JSON.stringify(null));
    this.ativo = {};

    localStorage.setItem(constants.enderecoSelecionadoKey, JSON.stringify(null));
    this.endereco = {};

    localStorage.setItem(constants.ambientes, JSON.stringify(null));
    this.ambientes = {};

    localStorage.setItem(constants.tipoosSelecionadoKey, JSON.stringify(null));
    this.tipoOS = {};

    localStorage.setItem(constants.anexosKey, JSON.stringify(null));
    this.anexos = {};
  }
}
